/* msd-compat.js — el índice de impresoras y la URL de sus consumibles, en un solo sitio.

   POR QUÉ EXISTE ESTE FICHERO (17/10/2026): la regla de «a dónde se va para ver los
   consumibles de una impresora» estaba sólo dentro del buscador de abajo
   (`sections/msd-buscador-consumibles.liquid`). Al querer el mismo atajo en el desplegable
   de la búsqueda, lo fácil era copiarla; y dos copias de una regla son dos reglas que al
   mes dicen cosas distintas. Así que la regla vive aquí y quien la necesite la pide.

   LO QUE SABE:
     cargar(url)        trae assets/msd-modelos.json una sola vez, aunque se pida veinte
     buscar(texto, mc)  los modelos que encajan con lo tecleado
     enlace(m, marca)   la colección filtrada de ese modelo

   COMO SE EMPAREJA, y no es evidente: se quitan espacios, guiones y puntos de los dos
   lados, porque el cliente escribe «MFC-7440» y el catálogo guarda «MFC 7440». Se compara
   contra «marca + modelo» y no sólo contra el modelo, que si no «epson c58» no encuentra
   la «Epson WF C5890DWF» cuando el campo Marca va vacío.
*/
window.MSDCompat = (function () {
  'use strict';

  var INDICE = null, COL = {}, MARCAS = [], promesa = null;

  function norm(s) {
    return (s || '').toLowerCase().replace(/[\s\-\.]/g, '');
  }

  function cargar(url) {
    if (promesa) return promesa;
    promesa = fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        INDICE = d.idx || {};
        COL = d.col || {};
        MARCAS = Object.keys(INDICE);
        return INDICE;
      })
      .catch(function () { INDICE = {}; return INDICE; });
    return promesa;
  }

  /* [etiqueta, valorFiltro, coleccion] -> URL de la colección filtrada.

     Ordenado por precio ascendente a propósito: quien busca el consumible de su impresora
     casi siempre quiere ver primero lo más barato, y así el genérico aparece antes que el
     original. La colección sólo tiene tinta y tóner, así que no se cuela ningún portátil
     por llevar el mismo número en el nombre.

     El filtro de marca va además del de modelo porque dos fabricantes llaman igual a un
     modelo ('C 3300' existe como OKI y como Ricoh). Es marca COMPATIBLE, no proveedor:
     filtrar por proveedor escondería justo las opciones baratas. */
  function enlace(m, marca) {
    var u = '/collections/' + (COL[m[2]] || COL.t)
          + '?filter.p.m.custom.impresoras=' + encodeURIComponent(m[1]);
    if (marca && marca !== 'Otras') {
      u += '&filter.p.m.custom.marca_compatible=' + encodeURIComponent(marca);
    }
    return u + '&sort_by=price-ascending';
  }

  function buscar(texto, marcaFija, tope) {
    if (!INDICE) return [];
    var toks = String(texto || '').trim().split(/\s+/).map(norm)
                 .filter(function (x) { return x.length; });
    // con menos de tres caracteres cualquier cosa encaja y el atajo estorbaría
    if (!toks.length || toks.join('').length < 3) return [];
    var claves = marcaFija ? [marcaFija] : MARCAS;
    var empieza = [], contiene = [];
    for (var i = 0; i < claves.length; i++) {
      var k = claves[i], mods = INDICE[k] || [];
      for (var j = 0; j < mods.length; j++) {
        var m = mods[j], n = norm(m[0]), hay = norm(k) + n, todas = true;
        for (var z = 0; z < toks.length; z++) {
          if (hay.indexOf(toks[z]) < 0) { todas = false; break; }
        }
        if (!todas) continue;
        var fila = { texto: k + ' ' + m[0], marca: k, modelo: m[0], url: enlace(m, k) };
        var pref = false;
        for (var y = 0; y < toks.length; y++) {
          if (n.indexOf(toks[y]) === 0) { pref = true; break; }
        }
        if (pref) empieza.push(fila); else contiene.push(fila);
      }
    }
    var corto = function (a, b) { return a.texto.length - b.texto.length; };
    empieza.sort(corto);
    contiene.sort(corto);
    return empieza.concat(contiene).slice(0, tope || 4);
  }

  return { cargar: cargar, buscar: buscar, enlace: enlace, norm: norm };
})();
